import { toast } from "sonner";
import { signal } from "./message";
import { useSignal } from "./use-signal";
import { APPMain_GF_SendMessageToHALP } from "@/odata/appu4dm/AppU4DMModel";
import { useTranslation } from "react-i18next";
import { CustomTypeOptions } from "i18next";
import { ConditionalKeys } from "type-fest";
import { useMachine } from "@/queries/machine/use-machine";

enum MessageToHalpLevel {
  Info = 1,
  Warn = 2,
  Error = 3,
}

interface MessageToHalp
  extends Omit<APPMain_GF_SendMessageToHALP, "Level" | "Message"> {
  Level: MessageToHalpLevel;
  Message: ConditionalKeys<
    CustomTypeOptions["resources"]["translation"]["messagesToHALP"],
    string
  >;
}

function messageToHalpSignal(workCenterId: string) {
  return signal<{ d: [MessageToHalp] }>({
    app: "AppU4DM",
    channel: "APPMain_GF_MessageToHALPSent",
    filters: `WorkcenterNId eq '${workCenterId}'`,
    enabled: !!workCenterId,
  });
}

export function useMessageToHalpSignal() {
  const { t } = useTranslation(undefined, { keyPrefix: "messagesToHALP" });
  const { machine } = useMachine();
  const machineId = machine?.EquipmentNId;

  return useSignal(messageToHalpSignal(machineId!), ({ d }) => {
    const [msg] = d;
    const showToast = {
      [MessageToHalpLevel.Info]: toast.info,
      [MessageToHalpLevel.Warn]: toast.warning,
      [MessageToHalpLevel.Error]: toast.error,
    }[msg.Level];

    const message = t(msg.Message, {
      interpolation: { escapeValue: false },
      replace: {
        p1: msg.Param1,
        p2: msg.Param2,
        p3: msg.Param3,
        p4: msg.Param4,
        p5: msg.Param5,
      },
    });

    showToast("", {
      duration: 10000,
      description: message,
    });
  });
}
